import api from './api';

export const accountsService = {
  // Get accounts dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/accounts/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching accounts dashboard stats:', error);
      throw error;
    }
  },

  // Cash & Bank Tracking
  getCashSummary: async (params = {}) => {
    try {
      const response = await api.get('/accounts/cash-summary', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching cash summary:', error);
      throw error;
    }
  },
  getCashAccounts: async (params = {}) => {
    try {
      const response = await api.get('/accounts/cash-accounts', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching cash accounts:', error);
      throw error;
    }
  },
  createCashAccount: async (data) => {
    try {
      const response = await api.post('/accounts/cash-accounts', data);
      return response.data;
    } catch (error) {
      console.error('Error creating cash account:', error);
      throw error;
    }
  },
  updateCashAccount: async (id, data) => {
    try {
      const response = await api.put(`/accounts/cash-accounts/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating cash account:', error);
      throw error;
    }
  },
  deleteCashAccount: async (id) => {
    try {
      const response = await api.delete(`/accounts/cash-accounts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting cash account:', error);
      throw error;
    }
  },
  getCashTransactions: async (params = {}) => {
    try {
      const response = await api.get('/accounts/cash-transactions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching cash transactions:', error);
      throw error;
    }
  },
  createCashTransaction: async (data) => {
    try {
      const response = await api.post('/accounts/cash-transactions', data);
      return response.data;
    } catch (error) {
      console.error('Error creating cash transaction:', error);
      throw error;
    }
  },
  
  // Get invoice aging report
  getInvoiceAgingReport: async (params = {}) => {
    try {
      const response = await api.get('/accounts/reports/invoice-aging', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching invoice aging report:', error);
      throw error;
    }
  },
  
  // Get sundry debtors report
  getSundryDebtorsReport: async (params = {}) => {
    try {
      const response = await api.get('/accounts/reports/sundry-debtors', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching sundry debtors report:', error);
      throw error;
    }
  },
  
  // Get outstanding payments report
  getOutstandingPaymentsReport: async (params = {}) => {
    try {
      const response = await api.get('/accounts/reports/outstanding-payments', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching outstanding payments report:', error);
      throw error;
    }
  },

  // Survival & Financial Control Reports
  getFounderControlReport: async (params = {}) => {
    try {
      const response = await api.get('/accounts/reports/founder-control', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching founder control report:', error);
      throw error;
    }
  },
  getBurnDisciplineReport: async (params = {}) => {
    try {
      const response = await api.get('/accounts/reports/burn-discipline', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching burn discipline report:', error);
      throw error;
    }
  },
  getRunwaySensitivityReport: async () => {
    try {
      const response = await api.get('/accounts/reports/runway-sensitivity');
      return response.data;
    } catch (error) {
      console.error('Error fetching runway sensitivity report:', error);
      throw error;
    }
  }
};

export default accountsService;

